import axios from "axios";

export const HOST = "https://planning.torrelines.it/api";
//export const HOST = "http://localhost:7000/api";
// export const HOST = "http://192.168.43.176:9001/api/external-scanner";

axios.defaults.withCredentials = false;

axios.defaults.timeout = 30000;
axios.defaults.baseURL = HOST;

export function getExcursion(excursionId) {
    return new Promise((resolve, reject) => {
        axios.get(`/booking/excursions/${excursionId}`).then(r => {
            resolve(r)
        }).catch(e => {
            console.log(e)
            reject(e)
        })
    });
}

export function getAvailability(excursionId, date, passengers) {
    return new Promise((resolve, reject) => {
        axios.get(`/booking/excursions/availability?excursionId=${excursionId}&date=${date}&passengers=${passengers}`).then(r => {
            resolve(r)
        }).catch(e => {
            console.log(e)
            reject(e)
        })
    });
}

export function createPaypalOrder(bookingRequestId) {
    return new Promise((resolve, reject) => {
        axios.post(`/booking/paypal/paymentIntent`, {
            id: bookingRequestId
        }).then(r => {
            resolve(r)
        }).catch(e => {
            console.log(e)
            reject(e)
        })
    });
}

export function approveOrder(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/booking/paypal/order`, data).then(r => {
            resolve(r)
        }).catch(e => {
            console.log(e)
            reject(e)
        })
    });
}

export function bookingRequest(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/booking/bookingRequest`, data).then(r => {
            resolve(r)
        }).catch(e => {
            console.log(e)
            reject(e)
        })
    });
}

export function paymentIntent(amount, description, bookingRequestId) {
    return new Promise((resolve, reject) => {
        axios.post(`/booking/stripe/paymentIntent`, {
            amount: amount,
            description: description,
            id: bookingRequestId
        }).then(r => {
            resolve(r)
        }).catch(e => {
            console.log(e)
            reject(e)
        })
    });
}

export function setBookingRequestStatus(bookingRequestId, status) {
    return new Promise((resolve, reject) => {
        axios.post(`/booking/controls/${bookingRequestId}`, {
            status: status
        }).then(r => {
            resolve(r)
        }).catch(e => {
            console.log(e)
            reject(e)
        })
    });
}